







































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import MenuEventsMixin from '@/views/layout/navigation/mixins/menu-events-mixin';
import { mixins } from 'vue-class-component';
@Component
export default class NavbarEventsMenu extends mixins(MenuEventsMixin)  {
  @Prop({ default: 'var(--color-mobile-menu-bg)' })
  backgroundColor: string;

  @Prop()
  changePlanClick;

  get stateColor(){
    return this.isNavbarEventsRed ? this.$colors.red : this.$colors.green;
  }

  get icon(){
    return this.isNavbarEventsRed ? 'fas fa-exclamation-circle' : 'fas fa-check-circle';
  }

  open_change_plan() {
    this.bus.emit('open-dialog', { name: 'ChangePlanDialog' });
    this.changePlanClick?.()
  }
}
